/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Updatenotes2Inputs */

const en_coinvestments_error_updatenotes2 = /** @type {(inputs: Coinvestments_Error_Updatenotes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update notes. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update notes. Please try again." |
*
* @param {Coinvestments_Error_Updatenotes2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_updatenotes2 = /** @type {((inputs?: Coinvestments_Error_Updatenotes2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Updatenotes2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_updatenotes2(inputs)
});
export { coinvestments_error_updatenotes2 as "coInvestments_error_updateNotes" }